// extracted by mini-css-extract-plugin
module.exports = {"headerbar":"Navigation_headerbar__JXK3D","sbslogo":"Navigation_sbslogo__1H4KE","mabulogo":"Navigation_mabulogo__2IaM4","social":"Navigation_social__2C-MJ"};